// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"868":"57c059a466180cac","3274":"711e1df9fdc616d5","4896":"84f6640a228a67d3","5259":"fc301960a33d88b1","8199":"f01407468f07465e","9564":"73f3f55fb953a44c"}[chunkId] + ".css";
};